import {
  FDBodyText, FDHeadlineText, FDHorizontalTabs, FDStack, FDTabPanel,
} from '@facet-wealth/design';
import React, { useState } from 'react';
import { dataAttrs } from 'Helpers/Testing';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';

export const RoadmapExecutiveSummaryNextUpTabs = ({ tabs }) => {
  const tabOptions = tabs
    .map(tab => {
      return {
        label: tab.attr('title'),
        value: tab.id(),
      };
    });

  const [tab, setTab] = useState(tabOptions[0].value);

  function getListItem(value, hint) {
    return (
      <li {...dataAttrs('next-up-section-tab-list-item')}>
        <Richtext
          Component={FDBodyText}
          size={'md'}
          richtext={hint === 'richtext'}
          value={value}
        />
      </li>
    );
  }

  const tabBody = (
    <FDStack direction={'column'} spacing={2}>
      {tabs?.find((item) => item.id() === tab).attr('items')
        ?.resources()
        .list()
        .map((item) => {
          if (!item.attr('actions')) {
            return null;
          }

          return (
            <FDStack direction={'column'} spacing={2} {...dataAttrs('next-up-section-tab-list')}>
              <FDHeadlineText value={item.attr('title')} size={'sm'} />
              <ul style={{ margin: '0px' }}>
                {item.attr('actions')?.map((action) => getListItem(action, item.metaField('actions').attr('hint')))}
                {item.attr('cumulativeTotal') && getListItem(item.attr('cumulativeTotal'), item.metaField('cumulativeTotal').attr('hint'))}
              </ul>
            </FDStack>
          );
        })}
    </FDStack>
  );

  // only show content if there is only one tab
  if (tabs.length === 1) {
    return tabBody;
  }

  return (
    <React.Fragment>
      <FDHorizontalTabs
        onChange={(event, v) => {
          setTab(v);
        }}
        value={tab}
        options={tabOptions}
      />
      <FDTabPanel
        id={tab}
        value={tab}
      >
        {tabBody}
      </FDTabPanel>
    </React.Fragment>
  );
};
